import QRCode from 'qrcode';


export default class DashboardStage {

	static selector = 'dashboard-stage';

	constructor(container) {
		this.el = {
			container
		};

		QRCode.toCanvas(this.el.container.querySelector('canvas'), 'https://www.experiencecrafted.com/showcase', { width: 250, height: 250 });
	}

}
